import { formatJson, formatXml, formatYaml } from './formatters';

export const TOOL_CATEGORIES = [
  { id: 'formatters', label: 'Formatadores' },
  { id: 'converters', label: 'Conversores' },
  { id: 'utilities', label: 'Utilitários' },
];

export const TOOL_DEFINITIONS = [
  {
    id: 'json-formatter',
    name: 'Formatador JSON',
    category: 'formatters',
    subcategory: 'JSON',
    description: 'Valide e formate rapidamente documentos JSON com identação de 2 espaços.',
    type: 'text-formatter',
    placeholder: '{ "nome": "João", "idade": 28 }',
    actionLabel: 'Formatar',
    processor: formatJson,
  },
  {
    id: 'xml-formatter',
    name: 'Formatador XML',
    category: 'formatters',
    subcategory: 'XML',
    description: 'Organize XML com identação consistente para leitura facilitada.',
    type: 'text-formatter',
    placeholder: '<nota><valor>1520</valor></nota>',
    actionLabel: 'Formatar',
    processor: formatXml,
  },
  {
    id: 'yaml-formatter',
    name: 'Formatador YAML',
    category: 'formatters',
    subcategory: 'YAML',
    description: 'Corrija espaçamento e ordenação de objetos YAML automaticamente.',
    type: 'text-formatter',
    placeholder: 'nome: Maria\nhabilidades:\n  - React\n  - Node.js',
    actionLabel: 'Formatar',
    processor: formatYaml,
  },
  {
    id: 'epoch-converter',
    name: 'Conversor Unix Epoch',
    category: 'converters',
    subcategory: 'Datas',
    description: 'Converta rapidamente valores epoch para datas legíveis ou o inverso.',
    type: 'epoch-converter',
  },
  {
    id: 'tax-calculator',
    name: 'Calculadora de Impostos',
    category: 'utilities',
    subcategory: 'Financeiro',
    description: 'Calcule automaticamente tributos sobre notas fiscais e pró-labore.',
    type: 'tax-calculator',
  },
];

export const DEFAULT_TOOL_ID = 'tax-calculator';

export const findToolById = (id) => TOOL_DEFINITIONS.find((tool) => tool.id === id);

export const groupToolsByCategory = (tools = TOOL_DEFINITIONS) =>
  tools.reduce((acc, tool) => {
    if (!acc[tool.category]) {
      acc[tool.category] = [];
    }
    acc[tool.category].push(tool);
    return acc;
  }, {});

const toolsModule = {
  TOOL_DEFINITIONS,
  TOOL_CATEGORIES,
  DEFAULT_TOOL_ID,
  findToolById,
  groupToolsByCategory,
};

export default toolsModule;
